import { render, staticRenderFns } from "./ProWhy2.vue?vue&type=template&id=efdf8b64&scoped=true&"
import script from "./ProWhy2.vue?vue&type=script&lang=js&"
export * from "./ProWhy2.vue?vue&type=script&lang=js&"
import style0 from "./ProWhy2.vue?vue&type=style&index=0&id=efdf8b64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efdf8b64",
  null
  
)

export default component.exports